import { errorEvent } from '@components/common/event-tracker';
import ErrorPageWrap from '@components/errorPage';
import type { NextPage } from 'next';
import { useEffect, useState } from 'react';
interface NotFound {
  statusCode?: any;
}
const NotFoundPage: NextPage<NotFound> = ({ statusCode }) => {
  const [fromPage, setFromPage] = useState<string>('');

  useEffect(() => {
    // Get current URL
    const currentUrl = window?.location?.href || '';

    // Get referrer if available
    const referrer = document.referrer || '';
    // Set fromPage to referrer if it exists, otherwise use current URL
    const pageSource = referrer || currentUrl;
    setFromPage(pageSource);

    let pathName =
      typeof window === 'object' && window?.location?.href
        ? window.location.href
        : '';
    errorEvent(statusCode ?? 404, pathName);
  }, []);
  return <ErrorPageWrap statusCode={statusCode ?? 404} fromPage={fromPage} />;
};

export default NotFoundPage;
